import { styled, StyleSystemProps, CheckboxV2 } from '@withjoy/joykit';
import { pxToRem } from '@withjoy/joykit/theme';

export const StyledCheckbox = styled(CheckboxV2)``;

const checkboxControlStyles: StyleSystemProps = {
  borderWidth: pxToRem(2),
  borderStyle: 'solid',
  borderRadius: 100,
  borderColor: 'mono3',
  width: 6,
  height: 6,
  backgroundColor: 'white',
  position: 'relative',
  color: 'white',
  _after: {
    content: '""',
    width: 9,
    height: 9,
    position: 'absolute',
  },
  _disabled: {
    backgroundColor: 'mono14',
    borderColor: 'mono14',
    color: 'white',
    _hover: {
      backgroundColor: 'mono8',
      borderColor: 'mono8',
      color: 'white',
    },
    _active: {
      backgroundColor: 'mono3',
      borderColor: 'mono3',
      color: 'mono8',
    },
  },
  _checked: {
    backgroundColor: 'mono14',
    borderColor: 'mono14',
    color: 'white',
    _hover: {
      backgroundColor: 'mono8',
      borderColor: 'mono8',
      color: 'white',
    },
    _active: {
      backgroundColor: 'mono3',
      borderColor: 'mono3',
      color: 'mono8',
    },
  },
  _hover: {
    backgroundColor: 'mono3',
    borderColor: 'mono3',
    color: 'mono8',
    boxShadow: 'none',
  },
  _active: {
    backgroundColor: 'mono8',
    borderColor: 'mono8',
    color: 'white',
  },
  _focus: {
    boxShadow: 'none',
  },
};

export const styles = {
  checkboxControl: checkboxControlStyles,
};
